import React, { useEffect, useReducer } from "react";
import { useSelector } from "react-redux";
import { images } from "../../../../../../assets/images";
import TemplatePreviewComponent from "../../../../../../components/commonComponents/templates/TemplatePreview";
import {
  INITIAL_STATE,
  templateReducer,
} from "../../../../reducers/templateReducer";
import { Divider, Flex, Typography } from "antd";
import {
  InfoCircleOutlined,
  SendOutlined,
  SmileOutlined,
} from "@ant-design/icons";
const { Text, Title } = Typography;

const TemplatePreview = ({ selectedTemplate }) => {
  // console.log(selectedTemplate);
  const { businessProfile } = useSelector((store) => store.Channel);
  const [templateData, templateDispatch] = useReducer(
    templateReducer,
    INITIAL_STATE,
  );

  useEffect(() => {
    templateDispatch({
      type: "update_template",
      data: selectedTemplate,
    });
  }, [selectedTemplate]);

  const { custom, authentication, carousel, categoryType } = templateData;
  const {
    header,
    headerVariable,
    body,
    bodyVariables,
    footer,
    buttons,
    buttonsOrder,
    ctaButtons,
    customButtons,
  } = custom || {};

  return (
    <div className="bg-white rounded-lg shadow-md">
      <Flex align="center" gap={6} className="w-full p-2 px-3">
        <Flex
          className="size-10 min-w-max rounded-full bg-[#E8E8EA] "
          align="center"
          justify="center"
        >
          {businessProfile?.profile_picture ? (
            <img
              className="size-10"
              src={businessProfile?.profile_picture}
              alt=""
            />
          ) : (
            <Text className="text-xs">Logo</Text>
          )}
        </Flex>
        <div>
          <Text className="text-sm truncate max-w-[150px] block">
            {businessProfile?.whatsapp_business_account_name}
          </Text>
        </div>
      </Flex>
      <div className="max-h-[450px] overflow-scroll">
        <TemplatePreviewComponent
          header={header}
          headerVariable={headerVariable}
          body={body}
          bodyVariables={bodyVariables}
          footer={footer}
          buttons={buttons}
          buttonsOrder={buttonsOrder}
          ctaButtons={ctaButtons}
          customButtons={customButtons}
          className={"w-full rounded-none h-[55vh] max-[1600px]:h-[55vh]"}
          authentication={authentication}
          carousel={carousel}
          category={categoryType}
        />
      </div>

      <div className="px-3 py-2">
        <Flex
          justify="space-between"
          align="center"
          className="p-2 border-[1px] border-[#E8E8EA] rounded-md"
        >
          <div className="text-xs text-[#6c6c6c] ">
            <SmileOutlined className="me-2" />
            <Text className="text-xs text-[#6c6c6c]">Message</Text>
          </div>
          <div className="text-xs ">
            <SendOutlined />
          </div>
        </Flex>
      </div>
    </div>
  );
};

export default TemplatePreview;
